function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button, Card, Typography } from 'seagull';
import styles from "./IntegrationCard.module.scss";
export default function IntegrationCard(props) {
  const {
    'data-testid': testid,
    icon,
    title,
    subTitle,
    mainAction
  } = props;
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": testid,
    className: styles.card
  }, icon, /*#__PURE__*/React.createElement("div", {
    className: styles.textContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "".concat(testid, "-sub-title")
  }, subTitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.actionButtonsWrapper
  }, mainAction));
}
IntegrationCard.LogoImg = props => /*#__PURE__*/React.createElement("img", _extends({
  height: 60,
  width: 60
}, props));
IntegrationCard.MainActionButton = props => /*#__PURE__*/React.createElement(Button, _extends({
  size: "small"
}, props));